import { useRef, useState } from 'react';
import { Upload } from 'lucide-react';
import { ReadingDots } from './ReadingDots';

/**
 * Zona reusable de subida con drag & drop + click. Llama onFile(file). El caller
 * decide qué hacer (subir a R2, mandar a la AI, etc.).
 */
export function FileDrop({
  onFile,
  onFiles,
  multiple,
  accept,
  label,
  busy,
  busyLabel,
  compact,
  danger,
}: {
  onFile: (f: File) => void;
  onFiles?: (files: File[]) => void;
  multiple?: boolean;
  accept?: string;
  label: string;
  busy?: boolean;
  busyLabel?: string;
  compact?: boolean;
  danger?: boolean;
}) {
  const ref = useRef<HTMLInputElement>(null);
  const [drag, setDrag] = useState(false);

  const handle = (list: FileList | null | undefined) => {
    if (busy || !list || list.length === 0) return;
    const files = Array.from(list);
    // Un solo archivo SIEMPRE va al flujo individual (permite revisar/editar a
    // mano). Solo 2+ archivos van al flujo bulk (auto-match).
    if (onFiles && files.length > 1) onFiles(files);
    else onFile(files[0]);
  };

  return (
    <div
      onClick={() => !busy && ref.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        handle(e.dataTransfer.files);
      }}
      style={{
        border: `2px dashed ${danger ? 'var(--red)' : drag ? 'var(--accent, #1f3a5f)' : 'var(--border)'}`,
        borderRadius: 10,
        padding: compact ? '10px 12px' : 16,
        textAlign: 'center',
        cursor: busy ? 'default' : 'pointer',
        background: drag ? 'var(--bg, #f3f4f6)' : 'transparent',
        fontSize: 'var(--fs-sm)',
        color: danger ? 'var(--red)' : 'var(--muted)',
      }}
    >
      {busy ? <ReadingDots label={(busyLabel ?? 'Reading').replace(/[.…\s]+$/, '')} /> : <><Upload size={13} strokeWidth={1.75} style={{ verticalAlign: 'text-bottom' }} /> {label}</>}
      <input
        ref={ref}
        type="file"
        accept={accept}
        multiple={multiple}
        style={{ display: 'none' }}
        onChange={(e) => {
          handle(e.target.files);
          e.target.value = '';
        }}
      />
    </div>
  );
}
